import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiBookOpen } from 'react-icons/fi';

function QuizSection() {
    const navigate = useNavigate();
    
    return (
        <div className="bg-white rounded-lg shadow p-6 space-y-4">
            <h2 className="text-xl sm:text-2xl font-bold text-[rgb(130,88,18)] mb-4 sm:mb-6">Quiz Repository</h2>
            <div
                onClick={() => navigate('/quiz-repository')}
                className="bg-gray-50 rounded-lg p-4 flex items-center space-x-4 hover:bg-gray-100 transition cursor-pointer border border-gray-200"
            >
                <div className="flex-shrink-0 text-[rgb(130,88,18)]">
                    <FiBookOpen size={40} />
                </div>
                <div className="flex-1">
                    <h3 className="text-base font-semibold text-gray-800">Explore and Generate Quizzes</h3>
                    <p className="text-sm text-gray-600">Access your quiz history, generate new quizzes, and join quiz battles.</p>
                </div>
                <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
            </div>
             <div className="flex justify-center mt-4">
                <button
                    onClick={() => navigate('/quiz-repository')}
                    className="inline-flex items-center px-4 py-2 bg-[rgb(130,88,18)] text-white rounded-full hover:bg-[rgb(110,68,0)] transition"
                >
                    <span>Go to Quiz Repository</span>
                    <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
                    </svg>
                </button>
            </div>
        </div>
    );
}

export default QuizSection;